import { render, staticRenderFns } from "./firstReview.vue?vue&type=template&id=274e329e&"
import script from "./firstReview.vue?vue&type=script&lang=js&"
export * from "./firstReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports